import type { LocaleData } from '../../../models/locale/locale-data';

export const data: LocaleData = {
  banner: 'Activate your FREE*',
  heroNumber: '10',
  heroCopy: 'year parts guarantee',
  heroSubCopy1: 'Your new appliance comes with a 2-year manufacturer\u2019s guarantee.',
  heroSubCopy2:
    'By registering your appliance, you will receive an additional 8-year parts guarantee \u2013 free* of charge.',
  registration: 'Call now to activate**',
  ctaPhoneText: '0800 085 5962',
  ctaPhoneLink: 'tel:08000855962',
  phoneSubCopy:
    "Activation by phone is quick and provides additional information about your manufacturer's and 10-year parts guarantee. Lines are open Monday to Friday 8am-8pm, Saturday 8am-6pm and Sunday 9am-6pm.",
  onlineCopy: 'Alternatively, you can register online.',
  ctaOnlineText: 'Click here.',
  ctaOnlineLink: 'https://haier.partners.domesticandgeneral.com/register/',
  onlineJourneyLaunch: 'Live',
  benefitsHeader: 'Activate your free guarantee today to:',
  benefits: [
    'Gain an additional 8-year parts guarantee',
    'Record your proof of purchase date',
    'Learn about important appliance and safety updates',
    'Get easy access to Haier-approved repair services',
  ],
  footerLinks: [
    {
      text: 'Website terms of use',
      link: 'https://www.domesticandgeneral.com/web-terms-conditions',
    },
    { text: 'Privacy notice', link: 'https://www.domesticandgeneral.com/mydata/haier' },
    { text: 'Cookie notice', link: 'https://www.domesticandgeneral.com/privacy-cookies-policy' },
  ],
  footerCopy:
    'Service plans and maintenance & support plans are provided by Domestic & General Services Limited. Company No. 1970780. Insurance policies are provided by Domestic & General Insurance PLC. Company No. 485850. Registered Office for both companies: Swan Court, 11 Worple Road, Wimbledon, London SW19 4JS. Both companies are registered in England and Wales. Domestic & General Insurance PLC is authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority. Financial register number 202111. Domestic & General Insurance PLC is an insurance undertaking, not an intermediary. We are the underwriter of the insurance and do not provide a personal recommendation or advice. Domestic & General Insurance PLC pay their sales agents periodic incentives (such as bonus payments) if they meet certain quality and sales targets. All prices include all applicable taxes (including IPT).',
  heroAsterix: [
    '* By registering your appliance, you will activate your FREE 10-year parts guarantee (inclusive of your legal guarantee period). If not activated, proof of purchase needed. Labour charges and other conditions apply. For T&C’s, visit <0>www.haier-europe.com/en_GB/pages/terms-conditions-extended-warranty</0>',
  ],
  heroAsterixLinks: ['www.haier-europe.com/en_GB/pages/terms-conditions-extended-warranty'],
  phoneNumberAsterix: [
    '** Haier has appointed Domestic & General Insurance PLC to provide product registration services and insurance policies to accompany its products. At Domestic & General, we treat your data with care. You can relax knowing it’s completely secure and only ever used responsibly. To find out more about how we use your information, scan the QR code or head to <0>https://www.domesticandgeneral.com/mydata/haier</0>',
  ],
  phoneNumberAsterixLinks: ['https://www.domesticandgeneral.com/mydata/haier'],
  additionalSmallPrint:
    'Haier is a trading name of Haier Smart Home UK & I Ltd. Registered in England and Wales. Company no. 02521528 with its registered office at 302 Bridgewater Place, Birchwood Park, Birchwood, Warrington WA3 6XG.',
  languageSwitcherPlaceholder: 'Select your country',
  languageList: [
    { label: 'Germany', value: 'de-DE' },
    { label: 'United Kingdom', value: 'en-EN' },
    { label: 'Spain', value: 'es-ES' },
    { label: 'France', value: 'fr-FR' },
    { label: 'Italy', value: 'it-IT' },
  ],
};
